import { Injectable } from '@angular/core';



@Injectable()
export class ErrorProvider {
	protected translations: any;

	protected errors = {
		'unknown_error': 'Ismeretlen hiba!',
		// REGISTER
		'email:missing': 'Hiányzó email cím!',
		'email_already_registered': 'Ezzel az email címmel már van regisztráció!',
		'email:already_exists': 'Ezzel az email címmel már van regisztráció!',
		'email:invalid': 'Hibás email cím!',
		'sex:missing': 'Hiányzó nem!',
		'city:missing': 'Hiányzó város!',
		'street_name:missing': 'Hiányzó utca név!',
		'street_type:missing': 'Hiányzó közterület!',
		'house_number:missing': 'Hiányzó házszám!',
		'postal_code:missing': 'Hiányzó irányítószám!',
		'postal_code:invalid': 'Hibás irányítószám!',
		'phone_area:missing': 'Hiányzó előhívószám!',
		'phone_area:invalid': 'Hibás előhívószám!',
		'phone_subscriber:missing': 'Hiányzó telefonszám!',
		'phone_subscriber:invalid': 'Hibás telefonszám!',
		'date_of_birth:invalid': 'Hibás születési idő!',
		'date_of_birth:too_young': 'A játékban csak 18 éven felüliek vehetnek részt! Ha elmúlt már 18 éves ellenőrizze a megadott születési dátumot!',
		'over_18:invalid': 'A játékban csak 18 éven felüliek vehetnek részt!',
		'date_of_birth:too_old': 'Kérjük, adja meg a valós születési éved!',
		'accept_terms:missing': 'El kell fogadni a játékszabályzatot!',
		'size:invalid': 'Nem választottál ruhaméretet!',
		'last_name:missing': 'Hiányzó vezetéknév!',
		'first_name:missing': 'Hiányzó keresztnév!',
		'invited_by:invalid': 'Kérlek add meg, honnan értesültél a promócióról!',
		// UPLOAD
		'code:invalid': 'Hibás kód!',
		'code:not_found': 'A kód nem található!',
		'code:already_uploaded': 'A kód már fel lett töltve!',
		'code:missing': 'Hiányzó kód!',
		'code:invalid_length': 'Nem 6 karakter hosszú a kód!',
		'code:extra_unavailable': 'A feltöltött extra kódok száma nem haladhatja meg a feltöltött csomagoláskódok számát. Tölts fel egy csomagoláskódot, hogy extra kódoddal is részt vehess a játékban.',
		'code:blacklisted': 'Ez a kódot nem töltheti fel!',
		'code:unauthorized': 'Az extra kódhoz nem a megadott email cím tartozik!',
		'extra:unavailable': 'Sajnáljuk, az extra kód igénylése nem sikerült! Kérünk, ellenőrizd, hogy elegendő csomagoláskódot töltöttél-e fel, illetve, hogy felhasználtad-e már a korábban megnyert extra kódot.',
		'purchase_time:invalid': 'Érvénytelen vásárlási dátum!',
		'prize:already_won': 'Ezt a nyereményt már egyszer megnyerte!',
		'user_not_found': 'Ez a email cím nem található!',
		'email_not_found': 'Ezzel az email címmel nincs regisztráció!',
		'user:not_found': 'Ez a email cím nem található!',
		'email:not_found': 'Ezzel az email címmel nincs regisztráció!',
		'promotion:outdated': 'A promóció február 1-én indul.',
		'token:invalid': 'Érvénytelen megerősítő kód.',
		'token:not_found': 'Érvénytelen megerősítő kód.',
		'token:already_confirmed': 'Érvénytelen megerősítő kód.',
		'recaptcha:invalid': 'Add meg kérlek a reCaptcha-t!',
	};

	public get(errorCode: string): string {
		return typeof this.errors[errorCode] !== 'undefined' ? this.errors[errorCode] : this.errors.unknown_error;
	}

	public getFieldName(errorMsg: string): string {
		const fields = errorMsg.split(':');
		let field;

		if (fields.length) {
			field = fields[0];
			if (field === 'date_of_birth' || field === 'over18') {
				field = 'year';
			}
			return field;
		}

		return '';
	}

	public getErrorCode(errorCode: string): string {
		const fields = errorCode.split(':');
		let code;

		if (fields.length) {
			code = fields[1];
			return code;
		}

		return '';
	}

	/**
	 * Get all the error codes and messages for a field
	 *
	 * @param field string
	 * @returns {Object[]}
	 */
	public getErrorMessagesForField(field: string): object[] {
		const fieldErrorMessages: object[] = [];
		for (const errorCode in this.errors) {
			if (this.getFieldName(errorCode) === field) {
				fieldErrorMessages.push({
					errorCode: this.getErrorCode(errorCode),
					errorMessage: this.errors[errorCode],
				});
			}
		}
		return fieldErrorMessages;
	}

	protected parseTranslation() {
		for (const translation in this.translations) {
			if (translation.includes('error')) {
				console.log(translation);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/core/providers/error.ts